module.exports = __webpack_public_path__ + "img/TEL-010.a056b4d7.png";